// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader-3wmjz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/privacy_center/consents/_consents.css
// module id = 1252
// module chunks = 1